<template>
  <div
    class="wallet"
    >
    <transition name="snack-bar-slide-y">
      <slot name="snackbar"/>
  </transition>
    <div class="wallet-settings-slot"
      :style="`
      ${$vuetify.breakpoint.smAndDown?'position: absolute;':'position: relative;'}
      ${$vuetify.breakpoint.smAndDown && !mobile_wallet_show_settings?'left: -100%;':'left: 0px;'}
      `"
      >
      <slot name="settings"/>
    </div>
    <!-- div is because of printing -->
    <div id="wallet-content-container" class="wallet-content-container" :style="$store.state.View.is_printing_mode?`height: ${getMaxHeight()}px !important;`:''">
    <div
      class="wallet-column"
      v-if="!$vuetify.breakpoint.smAndDown"
      :style="`
        z-index: ${$route.params.selected_column === 'left'?'1':'0'};
      `"
      >
      <slot name="left"/>
    </div>
    <div
      class="wallet-column"
      :style="`
      width: ${!$vuetify.breakpoint.smAndDown?
        !is_micro_view ? 'calc((100vw - 50px) / 3)': '' :
          '100vw'};
      z-index: ${$route.params.selected_column === 'center'?'1':'0'};
      `"
      >
      <slot name="center"/>
    </div>
    <div
      class="wallet-column"
      v-if="!$vuetify.breakpoint.smAndDown && !is_micro_view"
      :style="`
        z-index: ${$route.params.selected_column === 'right'?'1':'0'};
      `"
      >
      <slot name="right"/>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['mobile_wallet_show_settings', 'is_micro_view', 'show_snackbar'],
  methods: {
    getMaxHeight() {
      let takt_index = parseInt(this.$route.params.takt_index);
      let max_height = 0;
      [
        takt_index - 1, 
        takt_index,
        takt_index + 1
      ].forEach((takt_index) => {
        let height = document.getElementById('wallet_body_slot' + takt_index).scrollHeight;
        if(height > max_height) {
          max_height = height;
        }
      })
      return max_height;
    }
  }
}
</script>
<style>
  .wallet {
    position: absolute;
    display: flex;
    background-color: var(--v-color-1-base);
    color: white;
    overflow: hidden !important;
  }
  .wallet-column {
    position: relative;
    width: calc((100vw - 50px) / 3);
    height: 100%;
    /* overflow: hidden; */
  }
  .wallet-settings-slot {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 50px;
    padding: 3px;
    height: 100%;
    transition: left 0.2s ease-in-out;
    z-index: 1;
  }
  .wallet-content-container {
    position: relative;
    display: flex;
  }
  .snack-bar-slide-y-enter,
.snack-bar-slide-y-leave-to {
  transform: translate(-50%, calc(100% + 39px));
}

.snack-bar-slide-y-enter-active,
.snack-bar-slide-y-leave-active {
  transition: all 0.2s ease-in-out;
}

</style>
